import { createStyles, getDefaultZIndex, mediaHelper, rem } from '@affstore-ds/uikit'

export const useHeaderMainStyles = createStyles((theme) => ({
  divider: {
    display: 'block',
    height: rem(32),
  },
  balanceStack: {
    [`${mediaHelper.greaterThen('sm', true)}`]: {
      marginInlineEnd: rem(8),
    },
    marginInlineEnd: 0,
  },
  balanceWrapper: {
    font: theme.other.fonts.desktop.s.m.important,
    [mediaHelper.greaterThen('sm')]: {
      font: theme.other.fonts.desktop.s.l.extraImportant,
    },
  },
  header: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.other.colors.greyIron[4]}`,
    display: 'flex',
    justifyContent: 'space-between',
    left: 0,
    padding: `${theme.other.spacings[16]} ${theme.other.spacings[32]}`,
    position: 'sticky',
    top: 0,
    zIndex: getDefaultZIndex('app'),
  },
  headerControls: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    marginInlineStart: 'auto',
  },
  loyaltyBadgeMobile: {
    marginInlineStart: rem(-16),
  },
  mobileControls: {
    marginInlineStart: rem(-16),
  },
}))
